import { createApp } from "vue";
import { createPinia } from "pinia";
import { useAppStore } from "@/store";
import App from "@/app.vue";

import router from "@/router";
import auth, { configureAuth } from "@/utils/auth";
import { createSession } from "@/models/session";
import dialog from "@/utils/dialog";
import setupErrorHandling from "@/utils/error-handler";
import { createSignInComponent } from "vue-app-utils-web";
import { signInWithCustomToken } from "firebase/auth";
import DialogSendFeedback from "@/components/dialog-send-feedback.vue";
import DialogHelp from "@/components/dialog-help.vue";
import DialogQrcode from "@/components/dialog-qrcode.vue";
import DialogSquads from "@/components/dialog-squads.vue";
import DialogLocations from "@/components/dialog-locations.vue";
import DialogRaces from "@/components/dialog-races.vue";
import DialogTournamentChart from "@/components/dialog-tournament-chart.vue";
import DialogLeagueChart from "@/components/dialog-league-chart.vue";
import registerMarkdownComponents from "@/utils/register-markdown-components";

import vuetify from "@/plugins/vuetify";
import "roboto-fontface/css/roboto/roboto-fontface.css";
import "@mdi/font/css/materialdesignicons.css";
import "@/assets/app.css";

const app = createApp(App);
const pinia = createPinia();

app.use(pinia);

const store = useAppStore();
const session = createSession(store);

app.use(vuetify);
app.config.productionTip = false;

configureAuth(router, session, dialog);

app.provide("$auth", auth);
app.provide("$dialog", dialog);
app.provide("$store", store);
app.config.globalProperties.$auth = auth;
app.config.globalProperties.$dialog = dialog;
app.config.globalProperties.$store = store;

app.component("sign-in-and-save-to-the-cloud", createSignInComponent("mdi-cloud-check", "Sign in", "Your data will be saved to the cloud automatically."));
app.component("dialog-send-feedback", DialogSendFeedback);
app.component("dialog-help", DialogHelp);
app.component("dialog-qrcode", DialogQrcode);
app.component("dialog-squads", DialogSquads);
app.component("dialog-locations", DialogLocations);
app.component("dialog-races", DialogRaces);
app.component("dialog-tournament-chart", DialogTournamentChart);
app.component("dialog-league-chart", DialogLeagueChart);

registerMarkdownComponents(app);

setupErrorHandling(app, store);

auth.onReady(async () => {
  app.use(router);
  app.mount("#app");
  if (window.Cypress) {
    window.authSignOut = function () {
      return auth.signOut();
    };
    window.authSignInWithCustomToken = function (token) {
      return signInWithCustomToken(auth.auth, token).then((result) => {
        return auth.signIn(result.user, result);
      });
    };
  }
  return app;
});